import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Breadcrumb, Form, message } from 'antd';

import _ from 'lodash';
import organizationRoute from '../../route';

import text from './EmployeeRoleRegister.page.translation';

import FormEmployeeRoleRegister from './EmployeeRoleRegister.form';

import './EmployeeRoleRegister.style.less';

const EmployeeRoleRegisterForm = Form.create()(FormEmployeeRoleRegister);

export class EmployeeRoleRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      formValue: {},
    };
  }

  componentDidMount() {
    this.props.getAllModules();
    const tempUrl = this.props.location.pathname.split('/');
    if (tempUrl[tempUrl.length - 1] === 'edit') {
      const roleId = tempUrl[tempUrl.length - 2];
      this.props.getSingleEmployeeRole(roleId, this._cdmSetState);
    }
  }

  _cdmSetState = params => {
    this.setState({ formValue: params.payload });
  };

  _successRegisterCallback = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    this.setState({ isFetching: false }, () => {
      message.success(formatMessage(text.registerRoleSuccessMessage));
      this.props.history.push(organizationRoute.EMPLOYEE_ROLE_LIST);
    });
  };

  _successUpdateCallback = () => {
    const {
      intl: { formatMessage },
      detailRoleEmployee,
    } = this.props;
    const getRoleId = _.get(detailRoleEmployee, 'payload.role_id', '');
    this.setState({ isFetching: false }, () => {
      message.success(formatMessage(text.updateRoleSuccessMessage));
      this.props.history.push(
        organizationRoute.EMPLOYEE_ROLE_DETAIL.replace(':id', getRoleId),
      );
    });
  };

  _errorCallback = () => {
    this.setState({ isFetching: false }, () => {
      message.error('There is something error');
    });
  };

  _handleSubmit = param => {
    const tempUrl = this.props.location.pathname.split('/');
    if (tempUrl[tempUrl.length - 1] === 'edit') {
      const getId = tempUrl[tempUrl.length - 2];
      this.setState({ isFetching: true }, () => {
        this.props.updateEmployeeRole(
          getId,
          param,
          this._successUpdateCallback,
          this._errorCallback,
        );
      });
    } else {
      this.setState({ isFetching: true }, () => {
        this.props.registerEmployeeRole(
          param,
          this._successRegisterCallback,
          this._errorCallback,
        );
      });
    }
  };

  _setText = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    const tempUrl = this.props.location.pathname.split('/');
    const textContent = {};
    if (tempUrl[tempUrl.length - 1] === 'edit') {
      textContent.breadcrumbText = formatMessage(text.breadcrumbEdit);
      textContent.title = formatMessage(text.editRoleTitle);
    } else {
      textContent.breadcrumbText = formatMessage(text.breadcrumbRegister);
      textContent.title = formatMessage(text.registerRoleTitle);
    }

    return textContent;
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;

    const setText = this._setText();

    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={organizationRoute.EMPLOYEE_ROLE_LIST}>
                {formatMessage(text.breadcrumbEmployeeRoleList)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{setText.breadcrumbText}</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper ptop25 form-register-employee-wrapper">
          <span className="big-title border-bottom">{setText.title}</span>
          <div id="form-register-employee-role" className="form-wrapper">
            <EmployeeRoleRegisterForm
              formValue={this.state.formValue}
              btnText={formatMessage(text.btnSave)}
              allModules={this.props.allModules}
              intl={this.props.intl}
              location={this.props.location}
              onSubmit={this._handleSubmit}
              isFetching={this.state.isFetching}
            />
          </div>
        </div>
      </div>
    );
  }
}

EmployeeRoleRegister.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object,
  getAllModules: PropTypes.func.isRequired,
  allModules: PropTypes.array,
  registerEmployeeRole: PropTypes.func.isRequired,
  getSingleEmployeeRole: PropTypes.func.isRequired,
  updateEmployeeRole: PropTypes.func.isRequired,
  detailRoleEmployee: PropTypes.object,
};

export default EmployeeRoleRegister;
